/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useContext, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Grid } from "@material-ui/core"
import { MasterButton } from "App/Component/ui"
import {
  ShoppingCartIcon,
  TaxIcon,
  FileOpenIcon,
  FileSaveIcon,
  PencilIcon,
  AttachIcon,
} from "App/Assets/index"

import { FormContext } from "App/Component/layout/Penjualan/InputPenjualan/context/FormContext"
import {
  ModalMuat,
  ModalSimpan,
  ModalTaxDis,
  RESET_STATE_INPUT_PENJUALAN,
  getExportPenjualanById,
  getExportKwitansiById,
} from ".."
import {
  formatNumber,
  isNull,
  defaultDateDisplay,
  defaultToastError,
  formatRupiah,
  convertToValidPrice,
} from "App/utils/helpers"
import ModalBayar from "./Modal/ModalBayar/ModalBayar"
import { prefixNoRM } from "App/Component/layout/Registrasi/utils"
import ModalTemplate from "./Modal/ModalTemplate/ModalTemplate"
import fileDownload from "js-file-download"
import ModalIdgl from "App/Component/layout/Wms/PerbekalanFarmasi/TransaksiGudangUtama/PembelianWMS/ui/ModalIdgl/ModalIdgl"
import { useSelector } from "react-redux"
import WarningJurnal from "../WarningJurnal"
import { getToken } from "App/utils/cookies"
import { KODE_PRINTER_SETTING, URL_SETTING } from "utils/all"
import ModalNotif from "./Modal/ModalNotif/ModalNotif"
import { BASE_URL_3 } from "App/constants"
import { usePembulatanPenjualan } from "../helpers"
import { useDispatch } from "react-redux"
import { getSettingSIMRS } from "redux/actions/Setting"
import { numberToFixed } from "../helpers"

const useStyles = makeStyles({
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
})

export default function Perhitungan({
  perhitunganPenjualan,
  setPerhitunganPenjualan,
  handleClickReset,
  setNewData,
}) {
  const pembulatan = usePembulatanPenjualan()
  const dispatch = useDispatch()

  const classes = useStyles()
  const { formData, setFormData } = useContext(FormContext)
  const [showModalSimpan, setShowModalSimpan] = useState(false)
  const [showModalNotifikasi, setShowModalNotifikasi] = useState(false)
  const [showModalTaxDis, setShowModalTaxDis] = useState(false)
  const [showModalMuat, setShowModalMuat] = useState(false)
  const [showModalTemplate, setShowModalTemplate] = useState(false)
  const [showModalIdgl, setShowModalIdgl] = useState(false)
  const [dataNotif, setDataNotif] = useState([])

  const [showModalBayar, setShowModalBayar] = useState(false)
  const [loadingPrintRincian, setLoadingPrintRincian] = useState(false)
  const [loadingPrintKwitansi, setLoadingPrintKwitansi] = useState(false)
  const { setting } = useSelector((state) => state)
  const printerEnv = setting.printer_env
  const cetakButtonPenjualan = setting.cetak_button_penjualan

  const handleClickRincianPDF = async () => {
    setLoadingPrintRincian(true)
    const response = await getExportPenjualanById(formData.penjualan_id)
    if (response.state) {
      fileDownload(response.data, `Penjualan ID ${formData.penjualan_id}.pdf`)
      setLoadingPrintRincian(false)
    } else {
      defaultToastError(response.message)
      setLoadingPrintRincian(false)
    }
  }

  const handleClickKwitansiPDF = async () => {
    setLoadingPrintKwitansi(true)
    const response = await getExportKwitansiById(formData.penjualan_id)
    if (response.state) {
      fileDownload(response.data, `Penjualan ID ${formData.penjualan_id}.pdf`)
      setLoadingPrintKwitansi(false)
    } else {
      defaultToastError(response.message)
      setLoadingPrintKwitansi(false)
    }
  }

  const setPerhitungan = () => {
    const sumPerItem = (arr, type) => {
      if (!Array.isArray(arr)) return 0
      const total = arr.reduce((acc, e) => {
        if (isNull(e.hargaCustom) || isNull(e.qty)) return acc
        const jumlahRaw = (e.hargaCustom - e.nilai_diskon) * e.qty
        // Hanya barang yang dibulatkan per item
        const jumlah =
          type === "barang" ? pembulatan(jumlahRaw) : numberToFixed(jumlahRaw)
        return numberToFixed(acc + jumlah)
      }, 0)
      return numberToFixed(total)
    }

    const totalBarang = sumPerItem(formData.barang, "barang")
    const totalRikjang = sumPerItem(formData.rikjang, "rikjang")
    const totalJasa = sumPerItem(formData.jasa, "jasa")
    const totalFasilitas = sumPerItem(formData.fasilitas, "fasilitas")
    const totalPaket = sumPerItem(formData.paket, "paket")

    // Summary tidak dibulatkan
    const jumlah = numberToFixed(
      totalBarang + totalRikjang + totalJasa + totalFasilitas + totalPaket,
    )

    const potongan = formData.potongan

    const subTotal = numberToFixed(jumlah - potongan)

    const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
    const taxNumber = numberToFixed((taxPercent / 100) * subTotal)

    const total = numberToFixed(subTotal + taxNumber)
    const pembayaran = formData.pembayaran
    const sisa = numberToFixed(total - pembayaran)

    setPerhitunganPenjualan(() => {
      return {
        jumlah: jumlah,
        sub_total: subTotal,
        tax_number: taxNumber,
        total: total,
        potongan,
        total_barang: totalBarang,
        total_jasa: totalJasa,
        total_paket: totalPaket,
        total_rikjang: totalRikjang,
        total_fasilitas: totalFasilitas,
        pembayaran,
        sisa,
      }
    })
  }

  useEffect(() => {
    setPerhitungan()
  }, [
    formData.is_jurnal,
    formData.potongan,
    formData.tax_percent,
    formData.pembayaran,
    formData.penjualan_id,
    formData.reload,
    formData.reload_perhitungan,
    pembulatan,
  ])

  // Refetch setting hanya saat penjualan berganti (hindari loop/lag)
  useEffect(() => {
    if (!isNull(formData.penjualan_id)) {
      dispatch(getSettingSIMRS())
    }
  }, [dispatch, formData.penjualan_id])

  const handleClickPrint = (kop) => {
    return window.open(
      `http://localhost/${
        process.env.REACT_APP_PRINT_NAME
      }/public/api/print-kwitansi-penjualan?penjualan_id=${
        formData.penjualan_id
      }&tgl_penjualan=${defaultDateDisplay(
        formData.date,
        false,
      )}&rm_id=${prefixNoRM(formData.rm_id)}&nama=${formData.nama}&jml_bayar=${
        formData.pembayaran
      }&petugas=${formData.petugas}&penanggung=${
        formData.dokter_name
      }&kota_rumah_sakit=${
        printerEnv.kota_rumah_sakit
      }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
        KODE_PRINTER_SETTING.printer_kwitansi_penjualan
      }&nama_rumah_sakit=${printerEnv.nama_rumah_sakit}&fax_rumah_sakit=${
        printerEnv.fax_rumah_sakit
      }&no_tlp_rumah_sakit=${
        printerEnv.no_tlp_rumah_sakit
      }&alamat_rumah_sakit=${printerEnv.alamat_rumah_sakit}&kop=${kop}`,
      "MsgWindow",
    )
  }

  const handleClickPrintRincian = (kop) => {
    return window.open(
      `http://localhost/${
        process.env.REACT_APP_PRINT_NAME
      }/public/api/print-rincian-penjualan?url=${BASE_URL_3}/penjualan/detailsById/${
        formData.penjualan_id
      }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
        KODE_PRINTER_SETTING.printer_rincian_penjualan
      }&nama_rumah_sakit=${printerEnv.nama_rumah_sakit}&fax_rumah_sakit=${
        printerEnv.fax_rumah_sakit
      }&no_tlp_rumah_sakit=${
        printerEnv.no_tlp_rumah_sakit
      }&alamat_rumah_sakit=${printerEnv.alamat_rumah_sakit}&kop=${kop}`,
      "MsgWindow",
    )
  }

  const [showModalListKunjungan, setShowModalListKunjungan] = useState(false)
  const [showModalListPenjualan, setShowModalListPenjualan] = useState(false)

  const handleKeyPress = (event) => {
    if (event.key === "F2") {
      setShowModalListKunjungan(true)
      setShowModalListPenjualan(false)
      setShowModalMuat(true)
    }

    if (event.key === "F4") {
      setShowModalListKunjungan(false)
      setShowModalListPenjualan(true)
      setShowModalMuat(true)
    }

    if (event.key === "F6") {
      setFormData(RESET_STATE_INPUT_PENJUALAN)
    }
  }

  const handleClickIdgl = () => {
    setShowModalIdgl(!showModalIdgl)
  }

  React.useEffect(() => {
    document.addEventListener("keydown", handleKeyPress)
    return () => {
      document.removeEventListener("keydown", handleKeyPress)
    }
  }, [handleKeyPress])

  return (
    <>
      {showModalMuat && (
        <ModalMuat
          setShowModal={setShowModalMuat}
          showModal={showModalMuat}
          showModalListKunjungan={showModalListKunjungan}
          setShowModalListKunjungan={setShowModalListKunjungan}
          showModalListPenjualan={showModalListPenjualan}
          setShowModalListPenjualan={setShowModalListPenjualan}
        />
      )}

      {showModalTemplate && (
        <ModalTemplate
          setShowModal={setShowModalTemplate}
          showModal={showModalTemplate}
          setNewData={setNewData}
        />
      )}

      {showModalIdgl && (
        <ModalIdgl
          setShowModal={() => setShowModalIdgl(false)}
          idgl={`PJL-${formData.penjualan_id}`}
        />
      )}

      {isNull(formData.kunjungan_id) &&
        !isNull(formData.penjualan_id) &&
        isNull(formData.tagihan_id) &&
        showModalBayar && (
          <ModalBayar
            setShowModal={() => setShowModalBayar(false)}
            sisa={formatRupiah(convertToValidPrice(perhitunganPenjualan.sisa))}
            kasBankID={formData.kas_bank_id}
            kasBankName={formData.kas_bank_name}
          />
        )}

      {showModalSimpan && (
        <ModalSimpan
          setShowModal={() => setShowModalSimpan(false)}
          perhitunganPenjualan={perhitunganPenjualan}
          setShowModalNotifikasi={setShowModalNotifikasi}
          setDataNotif={setDataNotif}
        />
      )}

      {showModalNotifikasi && (
        <ModalNotif
          setShowModal={() => setShowModalNotifikasi(false)}
          dataNotif={dataNotif}
        />
      )}

      {showModalTaxDis && (
        <ModalTaxDis
          perhitungan={perhitunganPenjualan}
          setShowModal={() => {
            setShowModalTaxDis(false)
          }}
        />
      )}
      <div>
        <p className="fw-600 mb-1 mt-1">Perhitungan</p>
      </div>

      <div>
        <div className="w-full">
          <table
            width="100%"
            style={{
              lineHeight: "2rem",
            }}
          >
            <tbody>
              <tr>
                <td width="40%">Jumlah</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {formatNumber(perhitunganPenjualan.jumlah)}
                </td>
              </tr>
              <tr className={classes.textRed}>
                <td width="40%">Potongan</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {isNaN(perhitunganPenjualan.potongan)
                    ? 0
                    : formatNumber(perhitunganPenjualan.potongan)}
                </td>
              </tr>

              <tr>
                <td colSpan="2"></td>
                <td colSpan="2" className={classes.border}></td>
              </tr>

              <tr>
                <td width="40%">Sub Total</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {" "}
                  {isNaN(perhitunganPenjualan.sub_total)
                    ? 0
                    : formatNumber(perhitunganPenjualan.sub_total)}
                </td>
              </tr>
              <tr>
                <td width="40%">Tax ({formatNumber(formData.tax_percent)}%)</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {" "}
                  {isNaN(perhitunganPenjualan.tax_number)
                    ? 0
                    : formatNumber(perhitunganPenjualan.tax_number)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="w-full">
          <table
            width="100%"
            style={{
              lineHeight: "2rem",
            }}
          >
            <tbody>
              <tr>
                <td width="40%">Total</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {" "}
                  {formatNumber(perhitunganPenjualan.total)}
                </td>
              </tr>
              <tr>
                <td width="40%">Pembayaran</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {formatNumber(perhitunganPenjualan.pembayaran)}
                </td>
              </tr>

              <tr>
                <td colSpan="2"></td>
                <td colSpan="2" className={classes.border}></td>
              </tr>

              <tr>
                <td width="40%">Sisa</td>
                <td width="5%">:</td>
                <td width="5%">Rp. </td>
                <td width="50%" align="right">
                  {" "}
                  {formatNumber(perhitunganPenjualan.sisa)}
                </td>
              </tr>
            </tbody>
          </table>

          <p
            style={{
              fontSize: "12px",
              margin: "2rem 0",
              fontWeight: "500",
              letterSpacing: "0.5px",
              color: "black",
            }}
          ></p>
        </div>
      </div>

      <div
        style={{
          marginTop: "-1rem",
        }}
      >
        <WarningJurnal
          formData={formData}
          perhitunganPenjualan={perhitunganPenjualan}
        />

        <p
          style={{
            fontSize: "12px",
            margin: "1rem 0",
            fontWeight: "500",
            letterSpacing: "0.5px",
            color: "black",
          }}
        >
          Note : PPN berlaku untuk penjualan item rawat jalan & umum
        </p>

        <Grid container spacing={1}>
          <Grid item>
            <MasterButton
              type={"button"}
              color="green"
              name="Muat"
              onClick={() => setShowModalMuat(!showModalMuat)}
              size="sm"
              style={{
                padding: "0.6rem 1rem",
              }}
              withIcon={true}
              icon={<FileOpenIcon width="17px" height="17px" />}
            />
          </Grid>

          {formData.is_external &&
          (formData.is_lock === true || formData.is_close === true) ? (
            <Grid item>
              <MasterButton
                type={"button"}
                color="green"
                name="Bayar"
                onClick={() => setShowModalBayar(!showModalBayar)}
                size="sm"
                style={{
                  padding: "0.6rem 0.8rem",
                }}
                withIcon={true}
                icon={<ShoppingCartIcon width="17px" height="17px" />}
              />
            </Grid>
          ) : (
            <></>
          )}

          {!formData.is_lock && !formData.is_close && (
            <Grid item>
              <MasterButton
                type={"button"}
                color="green"
                name={`Tax & Disc`}
                onClick={() => setShowModalTaxDis(!showModalTaxDis)}
                size="sm"
                style={{
                  padding: "0.6rem 0.8rem",
                }}
                withIcon={true}
                icon={<TaxIcon width="12px" height="15px" />}
              />
            </Grid>
          )}
          {!formData.is_lock || !formData.is_close ? (
            <Grid item>
              <MasterButton
                type={"button"}
                color="primary-cyan"
                name={`Template`}
                onClick={() => setShowModalTemplate(!showModalTemplate)}
                size="sm"
                style={{
                  padding: "0.6rem 0.8rem",
                }}
                withIcon={true}
                icon={<TaxIcon width="12px" height="15px" />}
              />
            </Grid>
          ) : (
            <></>
          )}

          <Grid item>
            <MasterButton
              type={"button"}
              color="lightgreen"
              name="Simpan"
              onClick={() => setShowModalSimpan(!showModalSimpan)}
              size="sm"
              style={{
                padding: "0.6rem 0.8rem",
              }}
              withIcon={true}
              icon={<FileSaveIcon width="17px" height="17px" />}
            />
          </Grid>

          <Grid item>
            <MasterButton
              type={"button"}
              color="indigo"
              name={`IDGL`}
              onClick={handleClickIdgl}
              size="sm"
              style={{
                padding: "0.6rem 1rem",
              }}
              withIcon={true}
              icon={<AttachIcon width="15px" height="15px" fill="#fff" />}
            />
          </Grid>

          <Grid item>
            <MasterButton
              type={"button"}
              color="danger"
              name={`Reset`}
              onClick={handleClickReset}
              size="sm"
              style={{
                padding: "0.6rem 1rem",
              }}
              withIcon={true}
              icon={<PencilIcon width="12px" height="15px" />}
            />
          </Grid>
        </Grid>
      </div>

      <div className="mt-05">
        {!isNull(formData.penjualan_id) && (
          <Grid container spacing={1}>
            <Grid item>
              <MasterButton
                type="button"
                color={loadingPrintRincian ? "secondary" : "warning"}
                name={loadingPrintRincian ? "Loading.." : "PDF Rincian"}
                onClick={handleClickRincianPDF}
                size="md"
                withIcon={true}
                style={{
                  padding: "0.6rem 0.6rem",
                }}
                icon={<FileOpenIcon width="17px" height="17px" />}
              />
            </Grid>

            <Grid item>
              <MasterButton
                type="button"
                color={loadingPrintKwitansi ? "secondary" : "warning"}
                name={loadingPrintKwitansi ? "Loading.." : "PDF Kwitansi"}
                onClick={handleClickKwitansiPDF}
                size="md"
                withIcon={true}
                style={{
                  padding: "0.6rem 0.6rem",
                }}
                icon={<FileOpenIcon width="17px" height="17px" />}
              />
            </Grid>

            <Grid item>
              <MasterButton
                type={"button"}
                color="warning"
                name="Cetak Kwitansi"
                size="sm"
                style={{
                  padding: "0.6rem 0.6rem",
                }}
                onClick={() => handleClickPrint(0)}
                withIcon={true}
                icon={<FileOpenIcon width="17px" height="17px" />}
              />
            </Grid>

            {parseInt(cetakButtonPenjualan.kwitansi_dengan_kop) === 1 && (
              <Grid item>
                <MasterButton
                  type={"button"}
                  color="warning"
                  name="Cetak Kwitansi Kop"
                  size="sm"
                  style={{
                    padding: "0.6rem 0.6rem",
                  }}
                  onClick={() => handleClickPrint(1)}
                  withIcon={true}
                  icon={<FileOpenIcon width="17px" height="17px" />}
                />
              </Grid>
            )}

            <Grid item>
              <MasterButton
                type={"button"}
                color="warning"
                name="Cetak Rincian"
                size="sm"
                style={{
                  padding: "0.6rem 0.6rem",
                }}
                onClick={() => handleClickPrintRincian(0)}
                withIcon={true}
                icon={<FileOpenIcon width="17px" height="17px" />}
              />
            </Grid>
            {parseInt(cetakButtonPenjualan.rincian_dengan_kop) === 1 && (
              <Grid item>
                <MasterButton
                  type={"button"}
                  color="warning"
                  name="Cetak Rincian Kop"
                  size="sm"
                  style={{
                    padding: "0.6rem 0.6rem",
                  }}
                  onClick={() => handleClickPrintRincian(1)}
                  withIcon={true}
                  icon={<FileOpenIcon width="17px" height="17px" />}
                />
              </Grid>
            )}
          </Grid>
        )}
      </div>
    </>
  )
}
